// extracted by mini-css-extract-plugin
module.exports = {"centered":"AddSkillsDialog-m__centered___2u3zN","main":"AddSkillsDialog-m__main___3ISX0","secondary":"AddSkillsDialog-m__secondary___3kOQL"};